import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';

interface Props {}

const E: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.E');
    const { isH5 } = useDeviceDetect();

    return (
        <section
            id="rapid-mag-E"
            className={`rapid-mag-E ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-E'}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
            </div>
            {!isH5 && (
                <div className="pc-box">
                    <div className="t x">
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1762498946818/head-pc.png" />
                        </div>
                        <div className="msg">
                            <div className="icon">
                                <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479852687-ibq55f-compressed-Frame%201000009055.jpg" />
                            </div>
                            <p className="name w">{t('1_name')}</p>
                            <p className="text">{t('1_text')}</p>
                        </div>
                    </div>
                    <div className="b">
                        <div className="b-l">
                            <div className="b-l-t x">
                                <div className="img">
                                    <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479881005-xatf12-compressed-Frame%20161269785.jpg" />
                                </div>
                                <div className="msg">
                                    <p className="name s">{t('2_name')}</p>
                                    <p className="text">{t('2_text')}</p>
                                </div>
                            </div>
                            <div className="b-l-b x">
                                <div className="img">
                                    <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479895584-ayhq2t-compressed-Frame%20161269786.jpg" />
                                </div>
                                <div className="msg">
                                    <p className="name">{t('3_name')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="b-r">
                            <div className="b-r-t">
                                <div className="b-r-t-l x">
                                    <div className="img">
                                        <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479908050-5l9pde-compressed-Frame%20161269784.jpg" />
                                    </div>
                                    <div className="msg">
                                        <p className="name s">{t('4_name')}</p>
                                        <p className="text">{t('4_text')}</p>
                                    </div>
                                </div>
                                <div className="b-r-t-r x">
                                    <div className="img">
                                        <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479918940-4sjd8q-compressed-Frame%20161269787.jpg" />
                                    </div>
                                    <div className="msg">
                                        <p className="name w">{t('5_name')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="b-r-b">
                                <div className="b-r-b-l x">
                                    <div className="img">
                                        <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479929208-w0m7io-compressed-Frame%20161269789.jpg" />
                                    </div>
                                    <div className="msg">
                                        <p className="name w">
                                            {t.rich('6_name', {
                                                i: (tx: string) => <span className="i">{tx}</span>,
                                            })}
                                        </p>
                                    </div>
                                </div>
                                <div className="b-r-b-r x">
                                    <div className="img">
                                        <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479938490-s9k0oy-compressed-Frame%20161269790.jpg" />
                                    </div>
                                    <div className="msg">
                                        <p className="name w">{t('7_name')}</p>
                                        <div className="icon">
                                            <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1762479956279-w4td63-compressed-image%205155603.jpg" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isH5 && (
                <div className="h5-box">
                    <div className="t x">
                        <div className="img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1762498945755/head-m.png" />
                        </div>
                        <div className="msg">
                            <p className="name">{t('1_name')}</p>
                            <p className="text">{t('1_text')}</p>
                        </div>
                    </div>
                    <div className="l2">
                        <div className="l2-l x">
                            <div className="img">
                                <img
                                    src="https://websiteoss.ecoflow.com/figma-uploads/1762486380598-3xcymu-compressed-Frame%201612707985.jpg"
                                    alt={t('5_name')}
                                />
                            </div>
                            <div className="msg">
                                <p className="name">{t('5_name')}</p>
                            </div>
                        </div>
                        <div className="l2-r x">
                            <div className="img">
                                {/* EcoImg 在安卓手机FireFox上不展示图片 */}
                                <img
                                    src="https://websiteoss.ecoflow.com/figma-uploads/1762486408146-rdnlxx-compressed-Frame%201612707984.jpg"
                                    alt={t('4_name')}
                                />
                            </div>
                            <div className="msg">
                                <p className="name">{t('4_name')}</p>
                                <p className="text">{t('4_text')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="l3">
                        <div className="l3-l x">
                            <div className="img">
                                <img
                                    src="https://websiteoss.ecoflow.com/figma-uploads/1762486433377-n2lr7a-compressed-Frame%20161269802.jpg"
                                    alt={t.rich('6_name', {
                                        i: (tx: string) => {
                                            tx;
                                        },
                                    })}
                                />
                            </div>
                            <div className="msg">
                                <p className="name">
                                    {t.rich('6_name', {
                                        i: (tx: string) => <span className="i">{tx}</span>,
                                    })}
                                </p>
                            </div>
                        </div>
                        <div className="l3-r x">
                            <div className="img">
                                <img
                                    src="https://websiteoss.ecoflow.com/figma-uploads/1762486461184-5b80yz-compressed-Frame%201612707983.jpg"
                                    alt={t('2_name')}
                                />
                            </div>
                            <div className="msg">
                                <p className="name">{t('2_name')}</p>
                                <p className="text">{t('2_text')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="l4">
                        <div className="l4-l x">
                            <div className="img">
                                <img
                                    src="https://websiteoss.ecoflow.com/figma-uploads/1762486480465-bxxwp7-compressed-Frame%201612707981.jpg"
                                    alt={t('3_name')}
                                />
                            </div>
                            <div className="msg">
                                <p className="name">{t('3_name')}</p>
                            </div>
                        </div>
                        <div className="l4-r x">
                            <div className="img">
                                <img
                                    src="https://websiteoss.ecoflow.com/figma-uploads/1762486495917-1ocquc-compressed-Frame%201612707982.jpg"
                                    alt={t('7_name')}
                                />
                            </div>
                            <div className="msg">
                                <p className="name">{t('7_name')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};
export default E;
